const ORDER_UTILS = (() => {
  const getOrderStatus = (order) => {
    const orderState = order.state;
  
    // If the order has been canceled then we can stop here
    if (orderState === 'CANCELED') return 'CANCELED';
    const yPacks = order.orderItems.map(item => item.yPackage);
    if (orderState === 'FULFILLED' && yPacks.every(yPack => !yPack || yPack.state === 'DELIVERED')) {
      return 'DELIVERED';
    }
    if (orderState === 'FULFILLED' && yPacks.some(yPack => !!yPack && ['DELIVERED', 'SHIPPED'].includes(yPack.state))) {
      return 'SHIPPED';
    }
    
    // until further ux/ui is done for other states, we are defaulting to order is "placed" for any other states
    return 'PLACED';
  };

  const getYPackageStatus = (yPackage) => (
    [
      'FULFILLED',
      'SHIPPED',
      'DELIVERED',
    ].includes(yPackage?.state) ? yPackage.state : 'PLACED');

  return {
    getOrderStatus,
    getYPackageStatus,
  };
})();